import React, { Component } from 'react';
import T from 'i18n-react';

// Components
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
// Style
import './DialogText.css'

// Constants
import COLORS from '../../enums/ColorEnum';

class DialogText extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: props.open
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
           open: nextProps.open
        });
    }

    /**
     * Retourne le style du titre de la modal
     * @returns {Object}
     */
    getTitleStyle() {
        return {
            color: COLORS.GREEN,
            fontWeight: '500'
        };
    };

    /**
     * Retourne les configurations du bouton de la modal
     * @returns {Object}
     */
    getButtonConfigs() {
        return {
            backgroundColor: COLORS.GREEN,
            labelColor: COLORS.WHITE
        }
    };

    render() {
        const dialogStyle = {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
        };

        const modalTitleStyle = this.getTitleStyle();
        const modalButtonConfigs = this.getButtonConfigs();
        const text = this.props.errorMessage.replace(/\\n/g, '<br />');
        return (
            <Dialog title={this.props.title}
                    contentStyle={dialogStyle}
                    className="dialogText"
                    titleClassName="dialog-alert-title"
                    bodyClassName="dialog-alert-container"
                    titleStyle={modalTitleStyle}
                    modal={false}
                    autoScrollBodyContent={true}
                    open={this.state.open}
                    onRequestClose={this.props.onClose}>
                <div className="dialogText-content">
                    <div className="dialogText-message display-linebreak" dangerouslySetInnerHTML={{__html: text}}></div>
                    <RaisedButton label={T.translate('common.ok')}
                                  className="littleButton"
                                  onClick={this.props.onClose}
                                  {...modalButtonConfigs}/>
                </div>
            </Dialog>
        );
    }

}

export default DialogText;



// WEBPACK FOOTER //
// ./src/components/dialogLongText/DialogText.js